module.exports = __webpack_public_path__ + "static/5-274e8086ace6af44103218e8b2d25be0.jpeg";